import { z as zod } from "zod";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { RelatedInfoSchema } from "@/app/features/shared/types/schema";

export const SiteSpecialExhibitionsSchema = zod.object({
    intro: zod.object({
        title: zod.string().min(1, "Titel darf nicht leer sein"),
        subtitle: zod.string().nullish(),
        image: MediaRefSchema,
    }),
    relatedInfos: zod.array(RelatedInfoSchema),
});

export const SpecialExhibitionItemSchema = zod.object({
    documentId: zod.string(),
    title: zod.string().min(1, "Titel darf nicht leer sein"),
    subtitle: zod.string().nullish(),
    excerpt: zod.string().min(1, "Kurzbeschreibung darf nicht leer sein"),
    startDate: zod.string().min(1, "Startdatum fehlt"),
    endDate: zod.string().min(1, "Enddatum fehlt"),
    isHighlight: zod.boolean(),
    promoImage: MediaRefSchema,
    flyerImage: MediaRefSchema.nullish(),
});
